import Routing from "./Routes/Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import "./App.css";
import { NewUserContextProvider } from "./APIContext/NewUserContext";
import ScrollToTop from "./ScrollToTop";
import NavbarCustom from "./Components/NavbarCustom";

import { useLocation } from "react-router-dom";

function App() {
  

  return (
  
              <NewUserContextProvider>
                      <ScrollToTop />
                      <NavbarCustom />
                      <Routing />
              </NewUserContextProvider>
          
  );
}



export default App;







